<template lang="pug">
  div(:style="style")
</template>

<script>
export default {
  name: 'app-indicator',
  props: {
    color: {
      type: String,
      default: 'gray',
      validator: (val) => {
        return ['gray', 'grey', 'red', 'green', 'yellow', 'blue'].indexOf(val) != -1
      }
    },
    size: {
      type: [String, Number],
      default: 8
    },
    withAngle: Boolean
  },


  computed: {
    style () {
      let corner = this.size/2 + 'px'
      return {
        width: this.size + 'px',
        height: this.size + 'px',
        'border-radius': this.withAngle ? `${corner} ${corner} ${corner} 0px` : corner,
        background: this.hexColor
      }
    },

    hexColor () {
      switch (this.color) {
        case 'red': return '#ED0E51'
        case 'green': return '#2BC113'
        case 'yellow': return '#F2BE38'
        case 'blue': return '#19AFDE'
        default: return '#C4C4C4'
      }
    }
  }
}
</script>